import React from 'react';
import {
    Button,
    Dialog,
    // DialogActions,
    DialogContent,
    DialogContentText,
    Typography,
} from "@material-ui/core";
import { useHistory } from 'react-router';
import { CONNECTOR } from '../../containers/pagePath';
import "./Modal.css";


const CredentialModal = ({ openModal, handleClose, connector, changeConnector, saveMapper, connectors, dataItem }) => {
    const history = useHistory();
    const options = connectors.length > 0 ? connectors.map(connector => (
        <option
            key={connector.id}
            value={connector.id}>
            {connector.id} {'->'} {connector.db_name} {'->'} {connector.db_driver}
        </option>
    )) : [];
    const handleSaveMapper = () => {
        if (!connector || connector === null) {
            return;
        }
        handleClose();
        saveMapper();
    }
    const gotoConnector = () => {
        history.push({
            pathname: CONNECTOR
        });
    }

    return (
        <div>
            <Dialog
                open={openModal}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        openModal(false)
                    }
                }}
                // hideBackdrop={true}
                disableEscapeKeyDown={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                id="connector-modal"
            >
                <DialogContent>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <Typography variant='h5'>
                                Select Database Credential
                            </Typography>
                        </DialogContentText>
                        {
                            connectors.length > 0 ?
                                <div className="form-group mb-3 mt-3">
                                    <label htmlFor="org">Select Organization</label>
                                    <select
                                        className='form-control input-area-gd'
                                        defaultValue={connector}
                                        onChange={(e) => changeConnector(e.target.value)}
                                        required
                                    >

                                        <option>Select A Connector</option>
                                        {options}
                                    </select>
                                </div> : <center>
                                    <Typography variant='p'>
                                        No Database Credential
                                    </Typography>
                                    <br />
                                    <Button id="button-cancel" onClick={gotoConnector} color="primary">
                                        Create Connectors
                                    </Button>
                                </center>
                        }

                    </DialogContent>
                    {/* <DialogActions> */}
                    <div className="d-flex justify-content-between">
                        {
                            connectors.length > 0 ?
                                <Button id="button-cancel" onClick={handleSaveMapper} color="primary">
                                    Continue
                                </Button> : null
                        }

                        <Button id="button-cancel" onClick={handleClose} color="primary">
                            Close
                        </Button>
                    </div>
                    {/* </DialogActions> */}
                </DialogContent>
            </Dialog>
        </div>
    )

}
export default CredentialModal